"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetedConfig = exports.parseConfigWithTargeting = void 0;
var parse_1 = require("./parse");
Object.defineProperty(exports, "parseConfigWithTargeting", { enumerable: true, get: function () { return parse_1.parseConfigWithTargeting; } });
var target_1 = require("./target");
Object.defineProperty(exports, "TargetedConfig", { enumerable: true, get: function () { return target_1.TargetedConfig; } });
